export enum SearchWidgetFreeSearchFieldsEnum {
  FREESEARCH = 'freesearch',
  PLACE = 'place',
}
